<template>
  <div class="container">
    <div class="successAc">
      <v-flex class="middle">
        <v-layout class="success">
          <img src="../assets/cropped-pak.png" alt="background" />
        </v-layout>
        <h2>Ваучерот е успешно поништен!</h2>
      </v-flex>
    </div>
  </div>
</template>

<script>
export default {
  name: "Successvouchercheck",
  // props: {
  //   counter: {
  //     type: Number,
  //     required: true,
  //   },
  // },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.successAc {
  text-align: center;
}

.middle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.success {
  display: flex;
  justify-content: center;
}

.success img {
  max-width: 100%;
}

h2 {
  margin-top: 20px;
}
</style>
